<div class="drag-drop-info" [ngClass]="{ 'v-hidden': loading }">
  @if (infoVisible) {
    <div class="info">
      {{ 'global.add_photos' | transloco }} | {{ items?.length }}
      {{ 'upload.files_used' | transloco: { number: maxItems } }}
    </div>
  }
  @if (infoVisible) {
    <div class="info">
      {{ 'upload.upload_file_note' | transloco }} <strong>{{ maxFileSize }}Mb</strong>.
      {{ 'upload.upload_img_note' | transloco }} <strong>{{ maxImgRes }}px</strong>
    </div>
  }
  @if (error && !presentationOnly) {
    <div class="info error">
      {{ 'form.error.' + error | transloco }}
    </div>
  }
</div>
@if (error && !presentationOnly) {
  <div class="dialog-small-photos-error">
    <span class="info error">{{ 'form.error.' + error | transloco }}</span>
  </div>
}
@if (loading) {
  <div class="spinner-container p-absolute">
    <mat-spinner class="dark" [diameter]="20"></mat-spinner>
  </div>
}
<div class="drag-drop-container" cdkDropListGroup [ngClass]="{ 'v-hidden': loading }">
  <div
    cdkDropList
    [cdkDropListEnterPredicate]="dropListEnterPredicate"
    (cdkDropListDropped)="dropListDropped($event)"
  ></div>
  @if (staticImage?.url1x) {
    <div class="static-image-wrapper">
      <div class="static-box">
        <div
          class="photo"
          [ngStyle]="{ 'background-image': 'url(' + previewUrl($safeNavigationMigration(staticImage?.url1x)) + ')' }"
        ></div>
        <img class="frame-photo" [lazyLoad]="frameUrl(editorImage?.url1x)" />
      </div>
    </div>
  }
  @for (item of items; track item) {
    <div
      cdkDropList
      [cdkDropListEnterPredicate]="dropListEnterPredicate"
      (cdkDropListDropped)="dropListDropped($event)"
    >
      <div
        cdkDrag
        class="drag-drop-box"
        (click)="selectImage(item)"
        [class.selected]="selectedImageId && selectedImageId === item.id"
        (cdkDragMoved)="dragMoved($event)"
      >
        <div
          class="photo"
          [ngClass]="{ 'hover-dark': !presentationOnly && hoverDelete }"
          [lazyLoad]="previewUrl(item.url1x)"
        >
          @if (!presentationOnly) {
            @if (hoverDelete) {
              <button class="btn btn-remove" type="button" (click)="removeItem(item)">
                <span class="icon" [inlineSVG]="'/icons/icon-trash.svg'"></span>
              </button>
            }
            @if (!hoverDelete) {
              <button class="btn btn-close" type="button" (click)="removeItem(item)">
                <span class="icon" [inlineSVG]="'/icons/icon-close.svg'"></span>
              </button>
            }
          }
        </div>
      </div>
    </div>
  }
  @if (maxItems > items?.length && !presentationOnly && !photoEditorEnabled) {
    <div class="btn-box-container">
      @if (!alternativeLook) {
        <div class="btn-box">
          <div class="btn-container">
            <button class="btn btn-add-photo" type="button" (click)="inputFiles.click()">
              <span class="icon">+</span>
            </button>
            <input
              #inputFiles
              type="file"
              (change)="onFileChange($event)"
              multiple="multiple"
              accept=".jpg,.png,.jpeg"
            />
          </div>
        </div>
      } @else {
        <div class="alternative-btn-box" (click)="inputFiles.click()">
          <div class="btn-container">
            <button class="btn btn-add-photo" type="button">
              <span class="icon">+</span>
            </button>
            <span class="description">{{ 'global.upload_locale' | transloco }}</span>
            <input
              #inputFiles
              type="file"
              (change)="onFileChange($event)"
              multiple="multiple"
              accept=".jpg,.png,.jpeg"
            />
          </div>
        </div>
      }
    </div>
  }
  <ng-content></ng-content>
</div>
